import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  id: "modalVersion",
  class: "bounce-modal-animation fixed bottom-0 bg-[#ffffff] z-[102] w-full py-[35px] px-[20px] rounded-t-[24px]"
}
const _hoisted_3 = { class: "flex flex-col max-w-[400px] m-auto" }
const _hoisted_4 = { class: "text-2xl font-medium mb-2" }
const _hoisted_5 = { class: "text-base text-[#9094A8] leading-5 mb-1" }
const _hoisted_6 = { class: "text-xs text-[#9094A8] leading-4" }
const _hoisted_7 = { class: "text-xs text-[#9094A8] leading-4" }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  id: "modalVersion",
  class: "bounce-modal-animation flex flex-col justify-between h-full fixed bottom-0 bg-[#ffffff] z-[102] w-full pt-[95px] pb-[35px] px-[20px]"
}
const _hoisted_10 = { class: "flex flex-col max-w-[400px] w-full m-auto mb-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Transition, {
    name: "modalVersion",
    duration: { enter: 300, leave: 50 }
  }, {
    default: _withCtx(() => [
      (_ctx.isOpenModalToAndroid === false)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "absolute top-0 left-0 w-full h-full bg-[#9CA3AF] opacity-75 z-[100]" }, null, -1)),
            _createElementVNode("div", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClickOutside && _ctx.onClickOutside(...args))),
              class: "absolute top-0 left-0 w-full h-full backdrop-blur-sm z-[101]"
            }),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, _toDisplayString(this.appVersion?.title), 1),
                _createElementVNode("div", _hoisted_5, _toDisplayString(this.appVersion?.description), 1),
                _createElementVNode("div", _hoisted_6, " Текущая версия " + _toDisplayString(this.currentAppVersion), 1),
                _createElementVNode("div", _hoisted_7, " Доступная версия " + _toDisplayString(this.appVersion?.current_version), 1),
                _createElementVNode("button", {
                  class: "py-5 w-full mt-[48px] text-center bg-[#ffd930] text-sm rounded-xl leading-5",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.checkPlatform()))
                }, " Обновить приложение "),
                (this.appVersion?.detail != 'DIFFERENCE_MAJOR_VERSION')
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onDecline && _ctx.onDecline(...args))),
                      class: "py-5 w-full mt-[8px] bg-[#f5f5f7] text-sm rounded-xl leading-5"
                    }, " Напомнить позже "))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _cache[11] || (_cache[11] = _createElementVNode("div", { class: "absolute top-0 left-0 w-full h-full bg-[#9CA3AF] opacity-75 z-[100]" }, null, -1)),
            _createElementVNode("div", {
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onClickOutside && _ctx.onClickOutside(...args))),
              class: "absolute top-0 left-0 w-full h-full backdrop-blur-sm z-[101]"
            }),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("button", {
                class: "absolute top-[27px] left-[24px] w-[40px] h-[40px] rounded-full bg-[#FFF7D9]",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onToggleModalToAndroid()))
              }, [...(_cache[8] || (_cache[8] = [
                _createElementVNode("i", { class: "fas fa-arrow-left" }, null, -1)
              ]))]),
              _cache[10] || (_cache[10] = _createElementVNode("div", { class: "text-2xl font-medium mx-auto mb-2" }, " Откуда хотите установить? ", -1)),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", {
                  class: "h-[113px] flex flex-col justify-center my-[auto] w-full ml-0 mt-[8px] bg-[#f5f5f7] rounded-[16px] leading-5 text-left text-[16px] px-[24px] select-none",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.downloadRuStore()))
                }, " Из RuStore "),
                _createElementVNode("div", {
                  class: "h-[113px] flex flex-col justify-center my-[auto] w-full ml-0 mt-[8px] bg-[#f5f5f7] rounded-[16px] leading-5 text-left text-[16px] px-[24px] select-none",
                  onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.downloadGooglePlay()), ["prevent"]))
                }, [...(_cache[9] || (_cache[9] = [
                  _createTextVNode(" Из Google Play ", -1),
                  _createElementVNode("p", { class: "text-xs leading-2 opacity-60 mt-[4px]" }, [
                    _createTextVNode(" Если кнопка не работает, "),
                    _createElementVNode("br"),
                    _createTextVNode(" перейдите в Google Play и введите в поиске "),
                    _createElementVNode("br"),
                    _createTextVNode(" Force Money ")
                  ], -1)
                ]))])
              ])
            ])
          ]))
    ]),
    _: 1
  }))
}